<section class="article-component-cont">
  <header>
    <h3 class="ent-color"><i class="fas fa-file" aria-hidden="true"></i>Requirements</h3>
  </header>
  <div class="article-content requirement">
    <div aria-live="assertive">
      @if (showPotentialOutstandingMsg && !restrictChaseUser) {
        <ent-alert-message type="info">{{ message.requirementNotAvailable }}</ent-alert-message>
      }
      @if (showWarningMessage && !restrictChaseUser) {
        <ent-alert-message type="warning">{{ message.outstandingRequirementsSubmitInfo }}</ent-alert-message>
      }
      @if (showInfoMessage && !restrictChaseUser) {
        <ent-alert-message type="info">{{ message.outstandingRequirementsInfo }}</ent-alert-message>
      }
    </div>
    <!-- accordion start -->
    <ent-accordion (stateChange)="stateChange($event)" [autoScroll]="false">
      <!-- panel for outstanding requirements -->
      <ent-panel title="Outstanding requirements ({{ outstandingTableConfig.data.length }})" [opened]="accordianState.opened" class="outstanding-requirements">
        <span class="accordion__sub-title-hook">
          @if (accordianState.opened && outstandingTableConfig.data.length > 0 && !restrictChaseUser) {
            <ent-right-button-tray>
              <button type="button" routerLink="/requirements/{{contractNumber}}" (click)="triggerAnalytics();" entBorderButton class="resolve-btn">
                Resolve all requirements
                <i class="fas fa-arrow-circle-right" aria-hidden="true"></i>
              </button>
            </ent-right-button-tray>
          }
        </span>
        <div aria-live="assertive">
          @if (showDownloadWarningMessage && !restrictChaseUser) {
            <ent-alert-message type="warning">{{ message.fileDownload }}</ent-alert-message>
          }
        </div>
        <!-- outstanding requirements table -->
        <ent-primary-table [tableData]="outstandingTableConfig" (tableCellClick)="tableCellClick($event)">
          <ng-template #tableCelContentTemplate let-column="column" let-row="row">
            @if (column.columnKey === 'Action') {
              <div>
                <a (click)="tableCellClick({data: row})" class="policy-link">RESOLVE</a>
                @if (requirementsWithDownload.has(row.ID)) {
                  <span>
                    <i aria-hidden="true" class="fa-exclamation-triangle fas fileDownload"></i>
                    <span class="screen-reader-only">warning icon</span>
                  </span>
                }
              </div>
            }
          </ng-template>
        </ent-primary-table>
      </ent-panel>
      <!-- panel for completed requirements -->
      <ent-panel title="Completed requirements ({{ completedTableConfig.data.length }})">
        <!-- completed requirements table -->
        <ent-primary-table [tableData]="completedTableConfig" (tableCellClick)="tableCellClick($event)"></ent-primary-table>
      </ent-panel>
    </ent-accordion>
    <!-- accordion ends -->
  </div>
</section>
